import { render } from "./AdfRecordsTable.vue?vue&type=template&id=7b5d0e48&scoped=true"
import script from "./AdfRecordsTable.vue?vue&type=script&lang=js"
export * from "./AdfRecordsTable.vue?vue&type=script&lang=js"

import "./AdfRecordsTable.vue?vue&type=style&index=0&id=7b5d0e48&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b5d0e48"]])

export default __exports__
import QTable from 'quasar/src/components/table/QTable.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QTd from 'quasar/src/components/table/QTd.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QTable,QIcon,QTd,QTooltip,QBtn});
